import axios from 'axios';

const api = axios.create({
    // baseURL: 'http://localhost:8000/api',
    baseURL: 'https://webserver.becallcolombia.com/backend_entel/public/api',
    mode: 'cors',
});

const apiEmail = axios.create({
    baseURL: 'https://webserver.becallcolombia.com/enviocorreo/public/api',
    mode: 'cors',
});

const apiGenesys = axios.create({
    baseURL: 'https://megazord.en.tel/api',
    mode: 'cors',
});

function getData(url) {
    return api.get(`/${url}`)
    .then(response  => {
        return response;
    }).catch(error => {
        return {'catch': true, 'error': error.message};
    })
}
function postData(url, data) {
    return api.post(`/${url}`, data)
    .then(response => {
        return response.data;
    }).catch(error => {
        return {'catch': true, 'error': error.message, 'data': error.config.data, 'error2': JSON.stringify(error)};
    })
}

function postDataGenesys(data, tokenRc) {
    return apiGenesys.post(`/edealer`, data, {headers: {Authorization: `Bearer ${tokenRc}`}})
    .then(response => {
        console.log(response);
        return response.data;
    }).catch(error => {
        console.log(error)
        return {'catch': true, 'error': error?.message, 'data': error?.config?.data, 'error2': JSON.stringify(error)};
    })
}

function postEmail(url, data) {
    return apiEmail.post(`/${url}`, data)
    .then(response => {
        return response.data;
    }).catch(error => {
        return {'catch': true, 'error': error.message, 'data': error.config.data};
    })
}

function updateData(url, data) {
    return api.put(`/${url}`, data)
    .then(response => {
        return response.data;
    }).catch(error => {
        return {'catch': true, 'error': error.message, 'data': error.config.data};
    })
}
    
export {getData, postData, postEmail, postDataGenesys, updateData}